import { render, staticRenderFns } from "./addGiftNumberBatch.vue?vue&type=template&id=18e1787e&scoped=true"
import script from "./addGiftNumberBatch.vue?vue&type=script&lang=js"
export * from "./addGiftNumberBatch.vue?vue&type=script&lang=js"
import style0 from "./addGiftNumberBatch.vue?vue&type=style&index=0&id=18e1787e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1787e",
  null
  
)

export default component.exports